import React from "react";
import Grain from "../components/Grain";

export default function Confidentialite() {
  return (
    <div className="pt-28 section-dark min-h-screen">
      <section className="px-6 md:px-12 py-16 relative overflow-hidden">
        <Grain/>
        <div className="max-w-[860px] mx-auto relative z-10">
          <div className="eyebrow mb-4">Confidentialité</div>
          <h1 className="h-display text-5xl md:text-6xl">Politique de <span className="italic-accent">confidentialité.</span></h1>
          <div className="mt-12 space-y-8 text-text-cream/70 font-light leading-relaxed">
            <section>
              <h2 className="font-serif text-2xl text-text-cream mb-2">Données collectées</h2>
              <p>Lors d'une réservation ou prise de contact, nous collectons : prénom, nom, email, téléphone, ainsi que les informations relatives à votre demande. Ces données sont utilisées uniquement pour le traitement de votre demande.</p>
            </section>
            <section>
              <h2 className="font-serif text-2xl text-text-cream mb-2">Paiements</h2>
              <p>Les paiements sont traités par Stripe Inc. Aucune donnée de carte bancaire n'est stockée sur nos serveurs.</p>
            </section>
            <section>
              <h2 className="font-serif text-2xl text-text-cream mb-2">Vos droits (RGPD)</h2>
              <p>Vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour exercer ces droits, contactez-nous à studioeuclides25@gmail.com.</p>
            </section>
            <section>
              <h2 className="font-serif text-2xl text-text-cream mb-2">Cookies</h2>
              <p>Ce site utilise des cookies techniques nécessaires à son fonctionnement. Aucun cookie de traçage tiers n'est utilisé sans votre consentement explicite.</p>
            </section>
          </div>
        </div>
      </section>
    </div>
  );
}
